import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from "@/components/rw/tempTable/index";
import tempSearch from "@/components/rw/tempSearch/index";
import tempForm from "@/components/rw/tempForm/index";
import tempChart from "@/components/rw/tempChart/index";
import confirm from './confirm';
import { configGradeList, daRenHandle, gaoDaAgree, gaoDaConfirm, gaoDaHandle, gaoDaList, gdCompanyUpdate } from '../../../../api/apis';
import agreementShow from '@/views/pages/applyManage/gdApply/agreementShow';
export default {
  props: ["isCustomerServer"],
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart,
    confirm: confirm,
    agreementShow: agreementShow
  },
  data: function data() {
    var _this = this;

    return {
      leftFixed: {
        'id': 1,
        'number': 1,
        'price': 1,
        'user_company_card': 1,
        'user_company': 1,
        'status': 1,
        'quantity': 1,
        't_user.real_name': 1
      },
      sum: {
        quantity: 0
      },
      searchModel_1000: {
        "del": false,
        "id": "id_1000",
        "isCollapse": false,
        "operateData": [{
          "icon": "el-icon-search",
          "tag": "search",
          "title": "搜索",
          "type": "primary"
        }, {
          "icon": "el-icon-position",
          "tag": "export",
          "title": "导出",
          "type": "primary"
        }],
        "searchData": [{
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [],
            "title": "今天",
            "type": "button"
          }, {
            "field": [],
            "title": "昨天",
            "type": "button"
          }, {
            "field": [],
            "title": "最近7天",
            "type": "button"
          }, {
            "field": [],
            "title": "本月",
            "type": "button"
          }, {
            "field": [],
            "title": "本年",
            "type": "button"
          }, {
            "field": [],
            "title": "自定义",
            "type": "custom-datetime-range"
          }],
          "id": 0,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "申请时间",
          "type": 1,
          "remoteFunc": ["modelConditionFunc_0"]
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [],
            "title": "今天",
            "type": "button"
          }, {
            "field": [],
            "title": "昨天",
            "type": "button"
          }, {
            "field": [],
            "title": "最近7天",
            "type": "button"
          }, {
            "field": [],
            "title": "本月",
            "type": "button"
          }, {
            "field": [],
            "title": "本年",
            "type": "button"
          }, {
            "field": [],
            "title": "自定义",
            "type": "custom-datetime-range"
          }],
          "id": 1,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "审核时间",
          "type": 1,
          "remoteFunc": ["modelConditionFunc_1"]
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [],
            "title": "今天",
            "type": "button"
          }, {
            "field": [],
            "title": "昨天",
            "type": "button"
          }, {
            "field": [],
            "title": "最近7天",
            "type": "button"
          }, {
            "field": [],
            "title": "本月",
            "type": "button"
          }, {
            "field": [],
            "title": "本年",
            "type": "button"
          }, {
            "field": [],
            "title": "自定义",
            "type": "custom-datetime-range"
          }],
          "id": 2,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "确认时间",
          "type": 1,
          "remoteFunc": ["modelConditionFunc_2"]
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "0"
            }],
            "title": "申请中",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "1"
            }],
            "title": "等待同意",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "2"
            }],
            "title": "上传凭证",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "3"
            }],
            "title": "确认到账",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "-1"
            }],
            "title": "拒绝申请",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "-2"
            }],
            "title": "驳回收账",
            "total": 0,
            "type": "button"
          }],
          "id": 3,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "状态",
          "type": 0,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [{
              "desc": "会员编号",
              "key": "number",
              "value": ""
            }],
            "operator": ["gte", "lte", "gt", "lt", "eq", "ne", "like", "notLike", "in", "between"],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "type": "input-complex",
            "placeholder": "请输入",
            "field": [{
              "key": "user_company",
              "desc": "汇款人公司名称"
            }],
            "operator": []
          }, {
            "type": "input-complex",
            "placeholder": "请输入",
            "field": [{
              "key": "user_company_card",
              "desc": "汇款人公司账号"
            }],
            "operator": []
          }],
          "id": 4,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "按条件",
          "type": 2,
          "remoteFunc": []
        }],
        "type": "searchTemplate"
      },
      tableModel_1001: {
        "border": true,
        "del": false,
        "headerButton": [],
        "id": "id_1001",
        "isGroup": false,
        "isTree": false,
        "rowButton": [{
          "id": "191",
          "tag": "default",
          "title": "同意申请",
          "type": "primary"
        }, {
          "icon": "",
          "id": "192",
          "tag": "default",
          "title": "拒绝申请",
          "type": "danger"
        }, {
          "icon": "",
          "id": "193",
          "tag": "default",
          "title": "确认到账",
          "type": "success"
        }, {
          "icon": "",
          "id": "201",
          "tag": "default",
          "title": "驳回收账",
          "type": "danger"
        }, {
          "icon": "",
          "id": "210",
          "tag": "edit",
          "title": "营业执照修改",
          "type": "primary"
        }, {
          "icon": "",
          "id": "",
          "tag": "default",
          "title": "代理合同",
          "type": null
        }, {
          "icon": "",
          "id": "",
          "tag": "default",
          "title": "协议书",
          "type": null
        }],
        "showPagination": true,
        "showSelection": false,
        "showSummary": true,
        "stripe": false,
        "tableAutocompleteProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "tableModel": [{
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "ID",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "60",
          "prop": "id"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "会员编号",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "60",
          "prop": "number"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "金额",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "60",
          "prop": "price"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "汇款人公司账号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "65",
          "prop": "user_company_card"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "汇款人公司名称",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "65",
          "prop": "user_company"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "状态",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": "60",
          "prop": "status"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "盒数",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "60",
          "prop": "quantity"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "会员姓名",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "70",
          "prop": "t_user.real_name"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "会员等级",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": "80",
          "prop": "t_user.grade"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "申请时间",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": 160,
          "prop": "add_time"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "审核时间",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "approve_time"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "确认时间",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": 160,
          "prop": "confirm_time"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 0,
          "groupId": "",
          "label": "代发货协议",
          "rowAddField": "",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "100",
          "prop": "ex1"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 0,
          "groupId": "",
          "label": "代理协议",
          "rowAddField": "",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "100",
          "prop": "ex2"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 0,
          "groupId": "",
          "label": "居间合同",
          "rowAddField": "",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "100",
          "prop": "ex3"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "营业执照",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "image",
          "width": "100",
          "prop": "ex4",
          "desc": "建议尺寸640x320 不超过256kb",
          "file": {
            "checkSize": 0,
            "exData": {
              "type": "default"
            },
            "fileType": ".png,.jpg,.jpeg",
            "height": 320,
            "id": 3,
            "key": "ex4",
            "maxNum": 1,
            "maxSize": 256,
            "width": 640
          }
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "付款凭证",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "image",
          "width": "100",
          "prop": "ex5",
          "desc": "建议尺寸640x320 不超过256kb",
          "file": {
            "checkSize": 0,
            "exData": {
              "type": "default"
            },
            "fileType": ".png,.jpg,.jpeg",
            "height": 320,
            "id": 1,
            "key": "ex5",
            "maxNum": 1,
            "maxSize": 256,
            "width": 640
          }
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "取消原因",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "remark"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "取消时间",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "cancel_time"
        }, {
          "add": 0,
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "收款账号",
          "rowAddField": "",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bank_code"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "收款人名称",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bank_branch"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "收款开户行",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "bank_no"
        }, {
          "add": 0,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "",
          "label": "签订信息",
          "rules": [],
          "show": 0,
          "type": "custom",
          "width": "400",
          "prop": "company_detail"
        }, {
          "add": 0,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "",
          "label": "被授权方",
          "required": 0,
          "rules": [],
          "show": 0,
          "type": "text",
          "width": null,
          "prop": "user_company"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "营业地址",
          "required": 1,
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "user_business_address"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "法人代表",
          "required": 1,
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "user_legal_person"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "营业执照编号",
          "required": 1,
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "user_credit_code"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "经营者电话",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "90",
          "prop": "t_user.phone"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "经营者身份证号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "t_user.card_id"
        }, {
          "add": 1,
          "desc": "建议尺寸640x320 不超过256kb",
          "detail": 1,
          "groupId": "",
          "label": "用户给会员汇款凭证",
          "rules": [],
          "show": 1,
          "type": "image",
          "width": "160",
          "prop": "ex6",
          "file": {
            "checkSize": 0,
            "exData": {
              "type": "default"
            },
            "fileType": ".png,.jpg,.jpeg",
            "height": 320,
            "id": 4,
            "key": "ex6",
            "maxNum": 1,
            "maxSize": 256,
            "width": 640
          }
        }],
        "tableName": "t_gaoda_apply",
        "tableRadioProps": {},
        "tableSelectProps": {
          "status": {
            "data": [{
              "key": -1,
              "value": "拒绝申请"
            }, {
              "key": 0,
              "value": "申请中"
            }, {
              "key": 1,
              "value": "等待同意"
            }, {
              "key": 2,
              "value": "上传凭证"
            }, {
              "key": 3,
              "value": "确认到账"
            }, {
              "key": -2,
              "value": "驳回收账"
            }],
            "id": 0,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "t_user.grade": {
            "data": [{
              "key": null,
              "value": ""
            }],
            "id": 2,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": true,
            "remoteFunc": "tableFunc_select_t_usergrade"
          }
        },
        "tableSwitchProps": {},
        "title": "一品高达申请",
        "type": "tableTemplate"
      },
      remoteFunc: {
        modelConditionFunc_0: function modelConditionFunc_0(tag, relationData, resolve) {
          //筛选条件数据
          //[[{key:"type",value:"1"}]]
          var data = [];
          data = [[{
            key: "add_time",
            value: []
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 0, true)
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 1, true)
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 7, true)
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 30, true)
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 365, true)
          }], [{
            key: "add_time",
            value: []
          }]];
          resolve(tag, data);
        },
        modelConditionFunc_1: function modelConditionFunc_1(tag, relationData, resolve) {
          //筛选条件数据
          //[[{key:"type",value:"1"}]]
          var data = [];
          data = [[{
            key: "approve_time",
            value: []
          }], [{
            key: "approve_time",
            value: _this.$g.fun.getDateRange(new Date(), 0, true)
          }], [{
            key: "approve_time",
            value: _this.$g.fun.getDateRange(new Date(), 1, true)
          }], [{
            key: "approve_time",
            value: _this.$g.fun.getDateRange(new Date(), 7, true)
          }], [{
            key: "approve_time",
            value: _this.$g.fun.getDateRange(new Date(), 30, true)
          }], [{
            key: "approve_time",
            value: _this.$g.fun.getDateRange(new Date(), 365, true)
          }], [{
            key: "approve_time",
            value: []
          }]];
          resolve(tag, data);
        },
        modelConditionFunc_2: function modelConditionFunc_2(tag, relationData, resolve) {
          //筛选条件数据
          //[[{key:"type",value:"1"}]]
          var data = [];
          data = [[{
            key: "confirm_time",
            value: []
          }], [{
            key: "confirm_time",
            value: _this.$g.fun.getDateRange(new Date(), 0, true)
          }], [{
            key: "confirm_time",
            value: _this.$g.fun.getDateRange(new Date(), 1, true)
          }], [{
            key: "confirm_time",
            value: _this.$g.fun.getDateRange(new Date(), 7, true)
          }], [{
            key: "confirm_time",
            value: _this.$g.fun.getDateRange(new Date(), 30, true)
          }], [{
            key: "confirm_time",
            value: _this.$g.fun.getDateRange(new Date(), 365, true)
          }], [{
            key: "confirm_time",
            value: []
          }]];
          resolve(tag, data);
        },
        tableFunc_select_t_usergrade: function tableFunc_select_t_usergrade(tag, relationData, resolve) {
          //筛选项模型数组
          configGradeList({}).then(function _callee(res) {
            var data, i, item;
            return regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    data = [];

                    for (i in res) {
                      item = res[i];
                      data.push({
                        key: item.tag,
                        value: item.name
                      });
                    }

                    resolve(tag, data);

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            });
          });
        }
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;

    if (this.isCustomerServer) {
      //客服人员
      this.searchModel_1000.searchData = [this.searchModel_1000.searchData.pop()];

      for (var i in this.tableModel_1001.tableModel) {
        if (this.tableModel_1001.tableModel[i].label === '身份证号' || this.tableModel_1001.tableModel[i].label === '电话号码') {
          this.tableModel_1001.tableModel[i].show = 1;
        }
      }
    }
  },
  methods: {
    changeToStar: function changeToStar(str, len1) {
      var len2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var strLen = str.length;
      var stars = '';

      for (var i = 0; i < strLen - len1 - len2; i++) {
        stars += '*';
      }

      str = str.substr(0, len1) + stars + str.substr(strLen - len2);
      return str;
    },
    reqTableData: function reqTableData(params, resolve) {
      var _this2 = this;

      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
      }

      params.where = where;

      if (this.isCustomerServer) {
        params.where.status = 3;
      }

      this.$g.fun.startLoading();
      gaoDaList(params).then(function _callee2(res) {
        var i, companyInfo, m1, cardId;
        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.sum = res.sum;

                for (i in res.rows) {
                  if (res.rows[i].add_time >= '2022-09-01 00:00:00') {
                    res.rows[i].price = res.rows[i].quantity * 15;
                  } else {
                    res.rows[i].price = res.rows[i].quantity * 30;
                  }

                  companyInfo = res.rows[i];
                  m1 = '<div>被授权方：' + companyInfo.user_company + '</div>\n';
                  m1 += '<div>营业地址：' + companyInfo.user_business_address + '</div>\n';
                  m1 += '<div>法人代表：' + companyInfo.user_legal_person + '</div>\n';
                  m1 += '<div>营业执照编号：' + companyInfo.user_credit_code + '</div>\n';
                  m1 += '<div>经营者身份证号：' + companyInfo.t_user.card_id + '</div>\n';
                  m1 += '<div>经营者电话：' + companyInfo.t_user.phone + '</div>\n';
                  res.rows[i].company_detail = m1;
                  cardId = res.rows[i].t_user.card_id;

                  if (cardId.length > 4) {
                    res.rows[i].t_user.card_id_ex = res.rows[i].t_user.card_id;
                    res.rows[i].t_user.card_id = _this2.changeToStar(cardId, 0, 4);
                  }
                }

                resolve({
                  total: res.count,
                  data: res.rows
                });

                _this2.$g.fun.endLoading();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        });
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {
      if (isEdit) {
        params.id = row.id;
      }

      gdCompanyUpdate(params).then(function _callee3(res) {
        return regeneratorRuntime.async(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                resolve();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        });
      });
    },
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      }); //xxxDel({id:ids}).then(async res=>{
      //  resolve()
      //})
    },
    onClickLink: function onClickLink(prop, row) {//点击列表link类型回调
    },
    onClickRowButton: function onClickRowButton(btnIndex, row) {
      var _this3 = this;

      //点击列表按钮回调
      var buttonId = this.tableModel_1001.rowButton[btnIndex].id;

      if (buttonId === '191') {
        this.$refs['confirm'].show(row, function () {
          _this3.table.reloadData();
        });
      } else if (buttonId === '192') {
        this.$prompt('确定拒绝申请么？请输入备注信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^.+$/,
          inputErrorMessage: '请输入备注信息'
        }).then(function (_ref) {
          var value = _ref.value;
          gaoDaAgree({
            id: row.id,
            status: -1,
            remark: value
          }).then(function _callee4(res) {
            return regeneratorRuntime.async(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _this3.$message({
                      type: 'success',
                      message: '操作成功'
                    });

                    _this3.table.reloadData();

                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }
            });
          });
        });
      } else if (buttonId === '193') {
        this.$confirm('确定确认到账么，确认后立即分账', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          gaoDaConfirm({
            id: row.id
          }).then(function _callee5(res) {
            return regeneratorRuntime.async(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _this3.$message({
                      type: 'success',
                      message: '操作成功'
                    });

                    _this3.table.reloadData();

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            });
          });
        });
      } else if (buttonId === '201') {
        this.$prompt('确定驳回到账么？请输入备注信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^.+$/,
          inputErrorMessage: '请输入备注信息'
        }).then(function (_ref2) {
          var value = _ref2.value;
          gaoDaAgree({
            id: row.id,
            status: -2,
            remark: value
          }).then(function _callee6(res) {
            return regeneratorRuntime.async(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _this3.$message({
                      type: 'success',
                      message: '操作成功'
                    });

                    _this3.table.reloadData();

                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }
            });
          });
        });
      } else if (btnIndex === 5) {
        this.$refs.agreement.show({
          user_company: row.user_company,
          user_business_address: row.user_business_address,
          user_legal_person: row.user_legal_person,
          userInfo: {
            card_id: row['t_user.card_id_ex'],
            phone: row['t_user.phone']
          }
        }, 0);
      } else if (btnIndex === 6) {
        this.$refs.agreement.show({
          user_company: row.user_company,
          user_business_address: row.user_business_address,
          user_legal_person: row.user_legal_person,
          userInfo: {
            card_id: row['t_user.card_id_ex'],
            phone: row['t_user.phone']
          }
        }, 1);
      }
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {//点击列表头部按钮回调
    },
    onSummary: function onSummary(param) {
      var _this4 = this;

      //列表尾部合计回调
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }

        if (column.property === 'quantity') {
          sums[index] = _this4.sum.quantity;
        }
      });
      return sums;
    },
    onSwitchChange: function onSwitchChange(val, prop, row) {//列表中switch变化事件
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      //条件菜单按钮点击事件
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    },
    onRowButtonShow: function onRowButtonShow(btnIndex, row) {
      if (btnIndex === 0 || btnIndex === 1) {
        if (row.status === 0) {
          return true;
        }

        return false;
      } else if (btnIndex === 2 || btnIndex === 3) {
        if (row.status === 2) {
          return true;
        }

        return false;
      } else if (btnIndex === 4) {
        if (row.status === 0) {
          return true;
        }
      } else if (btnIndex === 5 || btnIndex === 6) {
        return true;
      }

      return false;
    }
  }
};